import type { Dispatch } from "react";
import { useEffect } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import type { RTContextState } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignTypes";
import { ECampaignsLoadingState } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignTypes";
import type { RTContextActions } from "app/pages/digital-marketing/keywords-campaigns/infra/RTContext.consts";
import { ERTContextReducerTypes } from "app/pages/digital-marketing/keywords-campaigns/infra/RTContext.consts";
import { KEYWORDS_CAMPAIGN_HOME_STATE } from "app/pages/digital-marketing/keywords-campaigns/keywords-campaign-homepage/KeywordsCampaignsHomePageConsts";

export const useHomePage = (dispatch: Dispatch<RTContextActions>, contextState: RTContextState) => {
    const {
        params: { campaignId },
        state,
    } = useCurrentStateAndParams();

    useEffect(() => {
        const isHomePage = state.name === KEYWORDS_CAMPAIGN_HOME_STATE;
        if (!campaignId || isHomePage) {
            dispatch({
                type: ERTContextReducerTypes.UpdateCurrentCampaignConfiguration,
                payload: { campaignConfiguration: null },
            });
        }
        const isHomepageWithError = isHomePage && contextState.loadingState === ECampaignsLoadingState.ERROR;
        if (isHomepageWithError && contextState.campaignsConfigurations?.length) {
            dispatch({
                type: ERTContextReducerTypes.UpdateLoadingState,
                payload: { loadingState: ECampaignsLoadingState.DONE },
            });
        }
        if (isHomepageWithError && !contextState.campaignsConfigurations?.length) {
            dispatch({
                type: ERTContextReducerTypes.UpdateLoadingState,
                payload: { loadingState: ECampaignsLoadingState.LOADING },
            });
        }
    }, [campaignId, dispatch, state.name]);
};
